// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"230":"72337eb2","279":"191ca122"}[chunkId] + ".js";
};